import { render, staticRenderFns } from "./RemarkStatusIcon.vue?vue&type=template&id=4df87d35&lang=pug"
import script from "./RemarkStatusIcon.vue?vue&type=script&lang=js"
export * from "./RemarkStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports